export const PAGE_LOAD_INDICATOR_SHOW = 'promotix:pageLoadIndicator:show';
export const PAGE_LOAD_INDICATOR_HIDE = 'promotix:pageLoadIndicator:hide';

const dispatchPageLoadIndicatorEvent = (eventName, detail = {}) => {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const showPageLoadIndicator = detail =>
  dispatchPageLoadIndicatorEvent(PAGE_LOAD_INDICATOR_SHOW, detail);

export const hidePageLoadIndicator = () => dispatchPageLoadIndicatorEvent(PAGE_LOAD_INDICATOR_HIDE);
